import { PaymentMethod } from '../common/constants'
import { environment } from '../environments/environment'
import { IVietQRRouteParams } from '../pages/VietQRPayment'
import { Booking } from '../types/booking'
import { PaymentStatus } from '../types/hotelTypes'
import { toQueryString } from './urlUtils'

export const getNextPage = (reservation: Booking) => {
  const { hotelId } = reservation
  const isPaid = reservation?.paymentStatus === PaymentStatus.Paid
  let url: string
  if (!reservation?.ezcloud?.identityNumber) {
    url = `/hotel/${hotelId}/identity-terms`
  } else if (!isPaid) {
    url = `/hotel/${hotelId}/payment?${toQueryString({
      amount: reservation.totalPrice,
      hotelId: hotelId,
      paymentMethod: PaymentMethod.VietQR_VietinBank,
      reservationId: reservation.id,
      bookingNumber: reservation?.ezcloud.reservationNumber,
    } as IVietQRRouteParams)}`
  } else {
    url = environment.kiosk ? `/hotel/${hotelId}/cardkey` : `/hotel/${hotelId}/checkin/success`
  }

  return { url }
}
